import { Link } from "react-router-dom";
import { LockSimpleIcon } from "@phosphor-icons/react";
import { PLAN_NAMES, PLAN_PRICES } from "@/lib/plans";

// Inline upgrade card shown in place of a locked feature.
export default function LockedFeature({ plan = "pro", title, desc, testId = "locked-feature" }) {
  const accent = plan === "press_box_pro" ? "#FDB927" : "#0A84FF";
  return (
    <div className="p-6 rounded-md bg-[#121212] border border-dashed flex flex-col sm:flex-row sm:items-center gap-4" style={{ borderColor: `${accent}66` }} data-testid={testId}>
      <span className="w-11 h-11 rounded-full grid place-items-center shrink-0" style={{ backgroundColor: `${accent}1f`, color: accent }}>
        <LockSimpleIcon weight="fill" size={20} />
      </span>
      <div className="flex-1">
        <p className="font-display font-bold text-xl uppercase tracking-tight">{title}</p>
        <p className="text-sm text-white/60">{desc}</p>
      </div>
      <Link
        to={`/pricing?plan=${plan}`}
        data-testid={`${testId}-cta`}
        className="inline-flex items-center justify-center px-5 py-2.5 rounded-md text-xs font-black uppercase tracking-wider whitespace-nowrap"
        style={{ backgroundColor: accent, color: plan === "press_box_pro" ? "#000" : "#fff" }}
      >
        Upgrade · {PLAN_NAMES[plan]} {PLAN_PRICES[plan]}
      </Link>
    </div>
  );
}
